export default __webpack_public_path__ + "static/media/severe.2ec216c1.svg";